(function($) {
  /**
   * MutationObserver
   * @since 2019-04-18
   */
   $.fn.observer = function(callback, options) {
    options = {
      subtree: true,
      childList: true,
      characterData: true,
      ...options
    }
    this.each(function() {
      var node = this;
      var cb = function(changes) {
        callback.call(node, changes);
      };
      new MutationObserver(cb).observe(this, options);
    })
  }
})(jQuery);